import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    },
    formControl: {
      width: '100%',
      minWidth: 240,
      maxWidth: 480,
    },
    input: {
      margin: theme.spacing(1, 2),
    },
    button: {
      margin: theme.spacing(3, 2),
    },
  }),
);
export default useStyles;
